import { Link } from "react-router-dom/cjs/react-router-dom.min";

const NotFound = () => {

    return (
        <>
            <div className="row">
                <div className="col-md-12 text-center mt-3">
                    <p> このページは存在しません。</p><br />
                    <Link to="/home" className="link__login"> 戻る </Link>
                </div>
            </div>
        </>
    )

}

export default NotFound;